import { useUI } from "providers/UIProvider"

import { Box, Flex, Text, Image } from "@chakra-ui/react"

import BdsLogo from "assets/img/bds-logo.png"

import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import DistrictsTable from "./DistrictsTable"
import MainLayout from "components/templates/MainLayout"
import useDistricts from "hooks/useDistricts"

const DistrictsTamplate = () => {
  const { T } = useUI()
  const { handleAddDistrict } = useDistricts()

  return (
    <MainLayout navigation>
      <Flex flexDirection={"column"} >
        <Flex
          width={"100%"}
          justifyContent="flex-end"
        >
          <Button
            leftIcon={
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                height={"34px"}
                width={"34px"}
                borderRadius={"xl"}
                background={"primary"}
              >
                <Icon
                  iconStyles={{ height: "17px", width: "17px" }}
                  name='add_person'
                />
              </Box>
            }
            styles={{
              width: "180px",
              height: "63px",
              fontSize: "xl",
              lineHeight: "28px",
            }}
            onClick={handleAddDistrict}
            text={T("employees.add")}
            variant='solid_white'
          />
        </Flex>
        <Box mt={"20px"}>
          <DistrictsTable />
          <Flex style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", height: "2rem" }}>
            <Text style={{
              opacity: "50%",
              fontSize: "11px",
              whiteSpace: "nowrap",
            }}>
              {"Powered by"}
            </Text>
            <a target='_blank'
              rel='noopener noreferrer' href="https://bds.ge">
              <Image alt="BDS Logo" src={BdsLogo} height="14px" />
            </a>
          </Flex>
        </Box>
      </Flex>
    </MainLayout>
  )
}
export default DistrictsTamplate

